import { Component, Input, OnChanges } from '@angular/core';
import { TableService } from '@pg-app/partner/dashboard/components/table/table.service';
import { format } from 'date-fns';
import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';
import { SortTypeEnum } from '@pg-app/shared/enums/sort-type.enum';
import { DATE_FORMAT_POST, MONTH_NAMES } from '../../constants/date-time-constants';

@Component({
  selector: 'np-table-ratio-converted',
  templateUrl: './ratio-converted.component.html',
  styleUrls: ['./ratio-converted.component.scss']
})
export class TableRatioConvertedComponent implements OnChanges {
  @Input()
  filter: any;

  public rows: Array<any> = [];
  public columns = [
      {
        title: 'Client name',
        name: 'clientName',
        width: '170px'
      },
      {
        title: 'Expected transaction size',
        name: 'expectedTransactionSize',
        width: '150px'
      },
      {
        title: 'Referral date',
        name: 'dateReferred',
        type: TableCellTypes.Date,
        width: '170px'
      },
      {
        title: 'Date account open',
        name: 'tradingAccountOpen',
        type: TableCellTypes.Date,
        width: '170px'
      },
      {
        title: 'Date last traded',
        name: 'dateTraded',
        sort: 'desc',
        type: TableCellTypes.Date,
        width: '170px'
      },
      {
        title: 'Referral to account open',
        name: 'referredToAccountOpen',
        width: '170px'
      },
      {
        title: 'Referral to last traded',
        name: 'referredToTrade',
        width: '170px'
      }
    ];

  constructor(private tableService: TableService) { }

  ngOnChanges() {
    this.getTableData();
  }

  public getTableData() {
    const month = this.filter ? MONTH_NAMES.indexOf(this.filter.month) : new Date().getMonth();
    const year = new Date().getFullYear();
    const start = this.filter ? new Date(this.filter.year, month, 1) : new Date(year, month, 1);
    const end = this.filter ? new Date(this.filter.year, month + 1, 0) : new Date(year, month + 1, 0);

    const tableData = {
      getAll: true,
      fromDate: format(start, DATE_FORMAT_POST),
      toDate: format(end, DATE_FORMAT_POST),
      sortType: SortTypeEnum.Desc
    };

    this.tableService.getTableConvertedRatioData(tableData).subscribe(
      data => {
        this.rows = data || [];
      }
    );
  }
}
